import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import DatePicker from 'react-datepicker';

require.ensure([], () => {  
    require('./WeekSheetApproval.less');
    require('./DatePicker.less');
});

class ApprovalHeader extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            selectDate: false
        };
    }

    // LIFECYCLE METHODS

    // EVENT HANDLERS

    handleCalendarClick = () => {
        this.setState({
            selectDate: true
        }, () => {
            if (this.refs.datePicker)
                this.refs.datePicker.handleFocus();
            else
                setTimeout(this.refs.datePicker.handleFocus, 100);
        });

        setTimeout(() => {
            moment.updateLocale('en', {
                week: { doy: 4, dow: 1 }
            });
        }, 150);
    }

    handleDateChange = (date) => {
        this.props.handleDateChange(date);
        setTimeout(() => {
            this.setState({
                selectDate: false
            });
        }, 350);
    }

    // RENDER METHOD

    render = () => {
        let formattedStartDate = this.props.startDay ? this.props.startDay.format("D.M.") : "";
        let formattedEndDate = this.props.endDay ? this.props.endDay.format("D.M.") : "";
        let formattedWeek = this.props.startDay ? "(Week " + this.props.startDay.isoWeek() + ")" : "";

        let weekClass = moment().format("ww-YYYY") === this.props.date.format("ww-YYYY") ? "label-day today" : "label-day";

        return (
        <div className="text-center">
                <div className="week-header">
                    <div className="panel-log-date">
                        {
                            this.props.loading ? null :
                            <i onClick={this.props.decrementWeek} className="md-chevron-left md-lg"></i>
                        }
                        <h4>
                            <span className={weekClass}>
                                <span>
                                    {
                                    this.state.selectDate ?
                                        <span className="no-show" style={{ display: "inline-block" }}><i onClick={this.handleCalendarClick} className="md-today"/>&nbsp;&nbsp;
                                            <DatePicker
                                                className="hideInput"
                                                ref="datePicker"
                                                dateFormat="YYYY-MM-DD"
                                                selected={this.props.startDay}
                                                onChange={this.handleDateChange}
                                                />
                                        </span>
                                        :
                                        <span><i onClick={this.handleCalendarClick} className="md-today"/>&nbsp;&nbsp;</span>
                                    }
                                    {formattedStartDate} - {formattedEndDate} {formattedWeek}
                                </span>
                            </span>
                        </h4>
                        {
                            this.props.loading ? null :
                            <i onClick={this.props.incrementWeek} className="md-chevron-right md-lg"></i>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

ApprovalHeader.propTypes = {
    date: PropTypes.object,
    decrementWeek: PropTypes.func,
    endDay: PropTypes.object,
    handleDateChange: PropTypes.func,
    incrementWeek: PropTypes.func,
    loading: PropTypes.bool,
    startDay: PropTypes.object
};

export default connect()(ApprovalHeader);



/** WEBPACK FOOTER **
 ** ./src/app/components/ApprovalHeader.js
 **/